// extracted by mini-css-extract-plugin
export default {"ContactInfo":"ContactInfo_ContactInfo__DW-SX","darkMode":"ContactInfo_darkMode__G0D+1"};